export default __webpack_public_path__ + "static/media/date.074872b7.svg";